import { memo } from 'react';

import { ToggleField, type ToggleFieldProps } from '@air/component-toggle-field';

import { useSharePrivateCollectionModal } from '~/components/SharePrivateCollectionModal/SharePrivateCollectionModalContext';

export type PermissionToggleFieldProps = Omit<ToggleFieldProps, 'isLoading'>;

export const PermissionToggleField = memo((props: PermissionToggleFieldProps) => {
  const { isSaving } = useSharePrivateCollectionModal();

  return (
    <div className="py-2">
      <ToggleField {...props} isLoading={isSaving} />
    </div>
  );
});

PermissionToggleField.displayName = 'PermissionToggleField';
